import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const MainBodyLayout = ({ children = null, withBack = false, title = null, className = '' }) => {
  const history = useHistory();
  const closeBanner = () => history.push('/dashboard/card/details');

  return (
    <div
      className={`d-flex flex-column loyalty-banner-body-layout main-layout-body-container ${className} main-body-layout`}>
      {withBack && (
        <div className="d-flex flex-row justify-content-between align-items-center">
          {withBack && (
            <div
              className="cursor-pointer text-hover"
              onClick={closeBanner}
              onKeyDown={closeBanner}
              role="presentation">
              <i className="icon icon-arrow_back-navigation text-f5 me-2" aria-label="Back" />
            </div>
          )}
        </div>
      )}
      {withBack && title && (
        <div className="d-flex flex-row justify-content-start align-items-center mt-3 mt-md-4">
          {/* mobile */}
          <p className="d-block d-md-none text-dark text-f4">{title}</p>
          {/* browser */}
          <p className="d-none d-md-block text-dark text-f3">{title}</p>
        </div>
      )}
      {children}
    </div>
  );
};

export default MainBodyLayout;

MainBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
};
